import type { MenuProps } from "antd";

export const createGeoSiteMenuItems = (): MenuProps["items"] => [
  {
    type: "group",
    label: "OVERVIEW",
    key: "group-overview",
    children: [{ key: "sites", label: "Sites" }],
  },
];
